<template v-if="hasAnyAssets">
    <h5 class="mt-3 mb-3">What you have to put towards it</h5>
    <template v-for="(assetGroup, i) in assetGroups" :key="i">
        <div v-if="assetGroup.assetItems.length > 0" class="card skin-card-haves mb-3">
            <div class="card-body">
                <h5 class="card-title">{{ assetGroup.title }}</h5>
                <span v-for="(assetItem, j) in assetGroup.assetItems" :key="j" class="list-group-item">
                    {{ assetItem }}
                </span>
            </div>
        </div>
    </template>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Retiree } from '@/guiide/ts/retiree';
import { StatePensionDescriptionInfo, retireeDescriber } from '@/guiide/ts/retireeDescriber';

const props = defineProps({
    retiree: {
        type: Object as () => Retiree | null,
        default: () => null,
    },
});

type AssetInfo = { title: string, assetItems: string[] };

const statePensionDescriptionInfo = computed<StatePensionDescriptionInfo>(() => retireeDescriber.statePensionDescription());

const hasAnyAssets = computed<boolean>(() => {
    for (const assetGroup of assetGroups.value) {
        if (assetGroup.assetItems.length > 0) {
            return true;
        }
    }
    return false;
});

const assetGroups = computed<Array<AssetInfo>>(() => {
    const assetGroups: AssetInfo[] = Array<AssetInfo>();
    
    if (statePensionDescriptionInfo.value.amount) {
        assetGroups.push({ title: "State Pension", assetItems: [ statePensionDescriptionInfo.value.description ] });
    }

    assetGroups.push({ title: "Pension pots", assetItems: props.retiree?.pensionPots.pots.map(s => s.description) ?? []});
    assetGroups.push({ title: "Final salary pensions", assetItems: props.retiree?.finalSalaries.assets.map(fs => fs.description) ?? []});
    assetGroups.push({ title: "Savings and investment pots", assetItems: props.retiree?.savingsPots.pots.map(s => s.description) ?? []});
    assetGroups.push({ title: "Other cash", assetItems: props.retiree?.otherCash.map(fs => fs.description) ?? []});
    assetGroups.push({ title: "Any other income", assetItems: props.retiree?.otherIncome.map(fs => fs.description) ?? []});

    return assetGroups;
});

</script>
